module.exports = __webpack_public_path__ + "static/media/POLITICA DE PRIVACIDAD_Movil Go.d9f9619f.pdf";